// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  i18nPrefix: '.',

  apiServer: {
    endpoint: 'https://leasing.localresidential.com.au/XMS/API/LocalResident/xmsWebApi',
    clientId: 'prod',
    domainCode: "LOCALRESHO",
    distributionChannelCode: "XRBE",
    cultureCode: "en-US",
    platformCode: 'RSP',
    action: 'WBEBooking'
  },
  storeKey: "PROD-RBE-CL-S-",
  application: "Local",
  webAppPathName: "/xms/rbe/localresident/prod",
  // keyCloakConfig: {
  //   url: "",
  //   realm: "mbc-stage",
  //   clientId: "protel-web"
  // },
  isUsingExternalIdentityServer: true,
  oktaConfig: {
    domain: "auth.localresidential.com.au",
    clientId: "xFOVU6kgRuUPdqH7AFHiL6rabXJVqRu2",
    authorizationParams: {
      audience: "https://localresidential.au.auth0.com/api/v2/"
    },
    apiUri: "https://localhost:4201",
    appUri: "http://localhost:4201",
    errorPath: "/error"
  },
  externalAuthorizationProvider: "Okta",
  headerRedirectUrl: '',
  allowSelectLanguage: true,
  availableLanguageCodes: ['en', 'de', 'pl', 'da', 'es'],
  appVersionName: '1.0.0',
  residentPortalSiteURL: 'https://portal.localresidential.com.au/xms/rsp/localresident/prod',
  // residentPortalSiteURL: 'https://localhost:4202',
  LogoHeaderLink: "https://localresidential.com.au/",
  MinimumLeaseStartDate: '2024-08-01',
  showEnvIndicator: false,
  propertyMinimumLeaseStartDate: [{
    propertyCode: 'BXH',
    date: '2026-01-12'
  }],
  showPromoCodeOnResultPage: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
